<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    version="1.1"
    x="0px"
    y="0px"
    viewBox="0 0 100 100"
    style="enable-background: new 0 0 100 100"
    xml:space="preserve"
  >
    <path
      d="M78.2,41h-2.1v-9.7C76.1,16.8,64.4,5,50,5C35.6,5,23.9,16.8,23.9,31.3V41h-2.1c-4.4,0-7.9,3.6-7.9,8v38c0,4.4,3.6,8,7.9,8  h56.5c4.4,0,7.9-3.6,7.9-8V49C86.2,44.6,82.6,41,78.2,41z M53.3,68.5v5c0,0.7-0.6,1.3-1.3,1.3h-4c-0.7,0-1.3-0.6-1.3-1.3v-5  c-1.8-1.1-3-3.1-3-5.5c0-3.5,2.9-6.4,6.4-6.4c3.5,0,6.4,2.9,6.4,6.4C56.4,65.4,55.1,67.4,53.3,68.5z M64.7,41H35.4v-9.7  c0-8.1,6.6-14.8,14.7-14.8c8.1,0,14.6,6.6,14.6,14.8V41z"
    ></path>
  </svg>
</template>

<script>
export default {
  name: "Lock",
};
</script>
